import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as MapPinIcon } from './mapPin.svg';

export const MapPin = IconHOC(MapPinIcon);
